<template>
	<div class="honorBox">
		
		<div class="honorBox-max">
			<div class="honorBox-banner">
				<div class="honorBox-banner-in">
					<div class="honorBox-banner-in-logo"></div>
				</div>
			</div>
			
			<div class="honorBox-box">
			
				<div class="honorBox-box-item" v-for="(item,index) in honorArr.list" :key="index">
					<div class="honorBox-box-item-tit">{{item.title}}</div>
					<div class="honorBox-box-item-text">{{item.text}}</div>
					<div class="honorBox-box-item-img">
						<img :src="$store.state.website + item.image" style="width: 100%;">
					</div>
				</div>
			
			
			</div>
			
			<div style="clear:both"></div>
			<div style="height:100px"></div>
			<PageBottom />
		</div>
		
		<div class="honorBox-min">
			<div class="honorBox-min-top" @click="tapMinfanhui()">
				<div class="min-caseBox-top-icon"></div>
				荣誉资质
			</div>
			
			<div class="honorBox-min-item-box">
				<div class="honorBox-min-item-box-item" v-for="(item,index) in honorArr.list" :key="index">
					<img :src="$store.state.website + item.image" style="width: 100%; vertical-align:middle;">
					<div>{{item.title}}</div>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'Honor',
		components: {
			PageBottom
		},
		data() {
			return {
				honorArr:[],
			}
		},
		mounted() {
			let that = this;
			
			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
			
			//资质荣誉
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/zzrylist', {
				// 'aa':1
			}).then(function(response) {
				console.log(response.data.data)
				that.honorArr = response.data.data;
				// console.log(that.honorArr);
			}).catch(function(error) {
				console.log(error);
			});
			
		},
		methods: {
			
			//移动端点击返回
			tapMinfanhui(){
				this.$router.push({
					path: '/'
				})
				this.$store.commit('tapNavItem', 6);
			},
		},
		
	}
</script>

<style>
	.honorBox {
		background: #fafafa;
	}

	.honorBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/ryzzBg.jpg);
		background-size: 100% 100%;
		margin-bottom: 100px;
		box-sizing: border-box;
	}

	.honorBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.honorBox-banner-in-logo {
		width: 586px;
		height: 70px;
		background-image: url(../assets/RYZZtIT.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.honorBox-box {
		width: 1200px;
		height: auto;
		/* background: pink; */
		margin: 0 auto;
	}

	.honorBox-box-item {
		width: 580px;
		height: 530px;
		background: #ffffff;
		float: left;
		margin-right: 20px;
		margin-bottom: 20px;
		padding: 30px 30px 0 30px;
		box-sizing: border-box;
		transition: all 0.5s;
	}

	.honorBox-box-item:hover {
		box-shadow: 0px 0px 20px #e6e6e8;
		transform: translateY(-10px);
		/* transform: scale(1.1); */
	}

	.honorBox-box-item:hover img {
		transform: scale(0.95);
	}

	.honorBox-box-item-tit {
		width: 100%;
		font-size: 24px;
		color: #19b7c8;
		padding-bottom: 20px;
		box-sizing: border-box;
	}

	.honorBox-box-item-text {
		width: 100%;
		/* height: 52px; */
		font-size: 16px;
		line-height: 28px;
		color: #666666;
		/* 超过2行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		/* background: red; */
	}

	.honorBox-box-item-img {
		width: 100%;
		height: auto;
		/* 		margin-top: 30px;
		box-sizing: border-box; */
	}

	.honorBox-box-item-img img {
		transition: all 0.5s;
	}
	.honorBox-min{
		display: none;
	}
	@media only screen and (max-width: 1200px) {
		.honorBox{
			width: 100%;
			height: 100%;
			background: red;
		}
		.honorBox-max{
			display: none;
		}
		.honorBox-min{
			display: block;
			width: 100%;
			height: 100%;
		}
		.honorBox-min-top{
			width: 100%;
			height: 2.75rem;
			background: #ffffff;
			border-bottom: 0.0625rem solid #ededed;
			box-sizing: border-box;
			position: relative;
			text-align: center;
			font-size: 1.125rem;
			color: #353535;
			line-height: 2.75rem;
		}
		.honorBox-min-item-box{
			width: 100%;
			height: calc(100% - 49px - 44px);
			background: #f8f8f8;
			overflow-y: auto;
			padding: 0.625rem 0 0.625rem 0.625rem;
			padding-bottom: 0;
			box-sizing: border-box;

		}
		.honorBox-min-item-box-item{
			width: calc(100% / 2 - 10px);
			height: auto;
			background: #ffffff;
			display: inline-block;
			vertical-align: top;
			font-size: 0.875rem;
			/* padding: 0 0 0 0.625rem; */
			box-sizing: border-box;
			margin-right: 0.625rem;
			margin-bottom: 0.625rem;
			color: #666666;
		}
		.honorBox-min-item-box-item div{
			padding: 0px 10px 10px 10px;
			box-sizing: border-box;
		}
		
	}
</style>
